/* @flow */
import * as React from 'react';
import ScrollWatch from 'components/ScrollWatch.jsx';

type Props = {
  items: *,
  scrolledIntoView: (item: *) => void,
};

class GapItems extends React.Component<Props, void> {
  handleScrolledIntoView = () => {
    this.props.scrolledIntoView(this.props.items);
  };

  render() {
    return (
      <ScrollWatch onEnter={this.handleScrolledIntoView} threshold={0.2}>
        <div />
      </ScrollWatch>
    );
  }
}

export default GapItems;
